import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import CharacterSection from "./components/CharacterSection";
import CpSection from "./components/CpSection";
import GenreSection from "./components/GenreSection";
import LatestSection from "./components/LatestSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <CharacterSection />
        <CpSection />
        <GenreSection />
        <LatestSection />
        <AboutSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}